import { IOption } from 'components/ui/select'

export default [
  {
    label: 'Österreich',
    value: 'AT',
  },
  {
    label: 'Deutschland',
    value: 'DE',
  },
  {
    label: 'Schweiz',
    value: 'CH',
  },
  {
    label: 'Sonstiges',
    value: '',
  },
] as IOption[]
